import { DateRangeOptionId } from '@/common/components';
import {
  SampleTrackingResponse,
  SampleTrackingStatus,
  SampleTrackingType,
  SampleCollectionLocation,
} from '@modules/study-insights/types';

export interface SampleTrackingProps {
  data: SampleTrackingResponse | undefined;
  isLoading: boolean;
  isError: boolean;
  onChangeParams: (params: SampleTrackingParams) => void;
}

export interface SampleTrackingParams {
  offset?: number;
  limit?: number;
  from?: Date | string | undefined;
  to?: Date | string | undefined;
  status?: SampleTrackingStatus[];
  sampleType?: SampleTrackingType[];
  collectionLocation?: SampleCollectionLocation;
  query?: string;
  sort?: Record<string, boolean>;
  retrospective?: boolean;
  selectedDateRange?: DateRangeOptionId;
}

export const PAGE_SIZE = 30;
